import legalContent from './legalContent';

const en = {
  room: {
    roomNumber: "Room Number",
    pseudo: "Username",
    pseudoPlaceholder: "Your username",
    pseudoColor: "Username Color",
    connection: "Connect",
    pinAlphanumericError: "The PIN must contain only letters and numbers.",
    pinLengthError: "The PIN must contain exactly 4 characters.",
    pseudoRequiredError: "Please enter a username.",
    pseudoLengthError: "The username must contain less than 17 characters or it will be cut off",
    pinPlaceholder: "XXXX"
  },
  mediaSelect: {
    title: "Choose a media type to start the game!",
    word: "Word",
    image: "Image",
    video: "Video",
    drawing: "Drawing"
  },
  ready: {
    title: "Are you ready?",
    button: "Start",
    cancel: "Cancel",
    waitTitle: "Waiting for the game to start...",
    starterTitle: "Waiting for players..."
  },
  answer: {
    title: "Answer",
    placeholder: "Enter your answer here...",
    errorMessage: "Please enter an answer",
    submit: "Submit"
  },
  exportMot: {
    title: "Write a Word!",
    placeholder: "Enter your word here...",
    submit: "Submit"
  },
  exportImage: {
    title: "Choose an image from your device",
    chooseButton: "Choose an image",
    zoomLabel: "Zoom:",
    moveFrame: "Move the frame",
    instructions: "Move the frame to select the area (500x500px)",
    instructionsSmall: "Use zoom to adjust - borders added automatically",
    confirm: "Confirm",
    successMessage: "Image confirmed and sent!"
  },
  exportVideo: {
    title: "Choose a video",
    chooseButton: "Choose a video",
    compressionInProgress: "Compression in progress...",
    moveFrame: "Move the frame",
    cropInstructions: "Click and drag to move the crop area",
    timelineTitle: "Select the part to keep",
    timelineDuration: "max",
    zoomTitle: "Zoom of the area (16:9 ratio)",
    zoomLabel: "Zoom:",
    currentArea: "Current area:",
    adjustInstructions: "Drag the handles or the rectangle to adjust the selection",
    confirm: "Confirm",
    cancel: "Cancel",
    connectionLostError: "Connection lost. Please reload the page.",
    gifTooLargeError: "Even after conversion, the GIF exceeds",
    gifConversionError: "Error during GIF conversion.",
    durationCheckError: "Unable to verify video duration.",
    metadataReadError: "Unable to read video metadata.",
    videoTooLargeError: "The edited video exceeds",
    videoProcessingError: "Error while processing the video.",
    reduceMessage: "Reduce the duration or the area."
  },
  exportVote: {
    title: "It's your turn to vote!",
    alertMessage: "Please select a player before sending!",
    submit: "Send"
  },
  canvas: {
    title: "Get your pencils ready!",
    colorLabel: "Color:",
    sizeLabel: "Size:",
    fillMode: "Fill",
    undoButton: "Undo",
    clearButton: "Clear all",
    submit: "Send"
  },
  waitingState: {
    title: "Waiting for players"
  },
  onTV: {
    title: "Look at the TV"
  },
  restart: {
    title: "Do you want to restart?",
    yes: "Yes",
    no: "No"
  },
  footer: {
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy"
  },
  popup: {
    title: "Terms of Service and Privacy Policy",
    message: "Please read and accept our terms of service and privacy policy before continuing.",
    termsTitle: "Terms of Service",
    privacyTitle: "Privacy Policy",
    nextButton: "I have read and accept - Next",
    acceptButton: "I have read and accept",
    backButton: "Back",
    termsContent: legalContent.en.termsContent,
    privacyContent: legalContent.en.privacyContent
  }
};

export default en;